import Game from 'Game';
import { report } from 'report';
import { sleep } from 'Utility/async';
import { IResourceData } from 'Utility/Resource/IResourceData';

export async function loadAvatar(resourceData: IResourceData): Promise<PIXI.Texture> {
    try {
        const texture = PIXI.Texture.from(resourceData.path);

        while (texture.width <= 1) {
            await sleep(5);
        }

        Game.resource.cacheResource(resourceData.key, texture);

        return texture;
    } catch (error) {
        report('Failed to load avatar', {
            error,
            once: true,
            sampleRate: 0.1,
            fingerprint: 'loadAvatar:FailedToLoad',
            tags: {
                platform: 'Facebook',
            },
        });
        return Game.resource.get('no_avatar');
    }
}
